import React from 'react'
import RoundInfoLeftcom from '../../../../../component/Maindashboardright/RoundInfoLeftcom'

export default function RoundInfoLeft() {
  return (
    <div style={{display:'flex',marginLeft:'50px'}}>
      <RoundInfoLeftcom/>
    </div>
  )
}
